import { type StatisticBase } from 'entities/Analytics'

export const computeHasStatistic = <K extends string>(
  statistic: ReadonlyArray<StatisticBase<K>>
): boolean => {
  return statistic.some(({ value, prevValue }) => {
    const numberValue = Number(value)
    const numberPrevValue = Number(prevValue)

    return (
      (Number.isFinite(numberValue) && numberValue > 0) ||
      (Number.isFinite(numberPrevValue) && numberPrevValue > 0)
    )
  })
}
